import React from 'react';
import { data } from '@/data';
import { useTranslation } from '@/hooks/useTranslation';

const Footer = () => {
  const t = useTranslation();
  
  return (
    <footer className="bg-gradient-to-r from-slate-800 to-stone-800 text-stone-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="text-center space-y-4">
          <p className="text-sm font-lora">
            <a
              href={`mailto:${data.musician.email}`}
              className="hover:text-stone-100 transition-colors"
            >
              {data.musician.email}
            </a>
          </p>
          <p className="text-xs text-stone-400 font-lora">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;